import React from 'react'
import { Model, WhenModel } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'

export default function ViewDomainSmartview (props) {
  return (
    <Smartview header='Domæne'>
      <Model resourceName='domains' id={props.id}>
        <WhenModel>
          <SmartviewTextGroup>
            <SmartviewText label='Domænenavn'>
              <Displays.Text name='domain' />
            </SmartviewText>
            <SmartviewText label='Pris'>
              <Displays.DenominationCurrency name='price' />
            </SmartviewText>
            <SmartviewText label='Status'>
              <Displays.Text name='status' />
            </SmartviewText>
          </SmartviewTextGroup>

          <SmartviewContentSeparator />
          {/* TODO - Ahrefs data */}
        </WhenModel>

        <Link route='app.domains.edit' parameters={{ domain: props.id }}>
          <Button text='Rediger' />
        </Link>
      </Model>
    </Smartview>
  )
}
